import { RegionalLanguage } from '@shared/common';

export const MASK_I18N_KEYS = {
  CATEGORY_EXTERIOR: 'CATEGORY_EXTERIOR',
  CATEGORY_INTERIOR: 'CATEGORY_INTERIOR',
  CATEGORY_WHEEL: 'CATEGORY_WHEEL',
  CATEGORY_MECHANICAL: 'CATEGORY_MECHANICAL',
  CATEGORY_UNDERCARRIAGE: 'CATEGORY_UNDERCARRIAGE',
};

export type MaskI18nKey = (typeof MASK_I18N_KEYS)[keyof typeof MASK_I18N_KEYS];

export type SupportedLang = RegionalLanguage.EN | RegionalLanguage.DE | RegionalLanguage.ES;

type LangDict = Readonly<Record<MaskI18nKey, string>>;

export const MASK_I18N: Readonly<Record<SupportedLang, LangDict>> = {
  [RegionalLanguage.EN]: {
    CATEGORY_EXTERIOR: 'Exterior',
    CATEGORY_INTERIOR: 'Interior',
    CATEGORY_WHEEL: 'Wheels',
    CATEGORY_WHEELS: 'Wheels',
    CATEGORY_MECHANICAL: 'Mechanical',
    CATEGORY_UNDERCARRIAGE: 'Mechanical',
  },
  [RegionalLanguage.DE]: {
    CATEGORY_EXTERIOR: 'Außen',
    CATEGORY_INTERIOR: 'Innenraum',
    CATEGORY_WHEEL: 'Räder',
    CATEGORY_WHEELS: 'Räder',
    CATEGORY_MECHANICAL: 'Mechanik',
    CATEGORY_UNDERCARRIAGE: 'Mechanik',
  },
  [RegionalLanguage.ES]: {
    CATEGORY_EXTERIOR: 'Exterior',
    CATEGORY_INTERIOR: 'Interior',
    CATEGORY_WHEEL: 'Ruedas',
    CATEGORY_WHEELS: 'Ruedas',
    CATEGORY_MECHANICAL: 'Mecánica',
    CATEGORY_UNDERCARRIAGE: 'Mecánica',
  },
};

export function resolveMaskTitle(lang: SupportedLang, dbTitleKey?: string): string | undefined {
  if (!dbTitleKey) return undefined;

  const dict = MASK_I18N[lang];
  if (!dict) return undefined;

  if (dbTitleKey in dict) return dict[dbTitleKey as keyof typeof dict];

  const normalized = `CATEGORY_${dbTitleKey}`;
  if (normalized in dict) return dict[normalized as keyof typeof dict];

  return undefined;
}
